import {HStack, Text} from 'platform/foundation';

import {Nullish, valueOrPlaceholder} from 'shared/web';

interface CalculationValueProps {
  label: string;
  value: string | Nullish;
  isHighlighted?: boolean;
}

export function CalculationValue(props: CalculationValueProps) {
  return (
    <HStack justify="space-between" align="center" spacing={4}>
      <Text color="secondary" alternative={props.isHighlighted ? true : undefined}>
        {props.label}
      </Text>
      <Text color={props.isHighlighted ? 'link' : 'primary'} alternative>
        {valueOrPlaceholder(props.value)}
      </Text>
    </HStack>
  );
}
